import React, { useState, useEffect } from 'react';
import Step1Main from './DepositSteps/Step1Main';
import Step2Bank from './DepositSteps/Step2Bank';
import Step3Crypto from './DepositSteps/Step3Crypto';
import StepThanks from './DepositSteps/StepThanks';
import CryptoDepositModal from './DepositSteps/CryptoDepositModal';

const DepositModal = ({ isOpen, onClose, initialStep = 1, initialCrypto = null }) => {
  const [currentScreen, setCurrentScreen] = useState(initialStep);
  const [showCryptoModal, setShowCryptoModal] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState(null); // Nuevo estado

  useEffect(() => {
    if (isOpen && initialCrypto) {
      setSelectedCrypto(initialCrypto);
      setShowCryptoModal(true);
      onClose(); // Cerramos el modal principal inmediatamente
    }
  }, [isOpen, initialCrypto, onClose]);

  // Resetear el currentScreen cuando se cierra el modal
  useEffect(() => {
    if (!isOpen) {
      setCurrentScreen(1);
    }
  }, [isOpen]);

  // Actualizar currentScreen cuando cambia initialStep
  useEffect(() => {
    if (isOpen) {
      setCurrentScreen(initialStep);
    }
  }, [isOpen, initialStep]);

  const handleOverlayClick = (e) => {
    if (e.target.className === 'modal_overlay') {
      onClose();
    }
  };

  const handleCryptoSelect = (crypto) => {
    setSelectedCrypto(crypto);
    setShowCryptoModal(true);
    onClose();
  };

  const renderStep = () => {
    switch (currentScreen) {
      case 1:
        return <Step1Main setCurrentStep={setCurrentScreen} />;
      case 2:
        return <Step2Bank
          setCurrentStep={setCurrentScreen}
          setTransactionDetails={setTransactionDetails} // Agregar esta prop
        />;
      case 3:
        return <Step3Crypto setCurrentStep={setCurrentScreen} onCryptoSelect={handleCryptoSelect} />;
      case 4:
        return <StepThanks transactionDetails={transactionDetails} />; // Agregar esta prop
      default:
        return null;
    }
  };

  if (!isOpen && !showCryptoModal) return null;

  return (
    <>
      {isOpen && !initialCrypto && ( // Solo mostramos el modal principal si no hay crypto inicial
        <div className="modal_overlay" onClick={handleOverlayClick}>
          <div className="modal_content">
            <div className="modal_content_header">
              <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            {renderStep()}
          </div>
        </div>
      )}

      <CryptoDepositModal
        isOpen={showCryptoModal}
        onClose={() => {
          setShowCryptoModal(false);
          setSelectedCrypto(null);
        }}
        cryptoType={selectedCrypto}
      />

      {currentScreen === 4 && selectedCrypto && (
        <div className="modal_content_body">
          <h3 className="ppt_form_title mb-4 text-center">Deposit {selectedCrypto.name}</h3>
          {selectedCrypto.error ? (
            <div className="text-center mb-3">
              <p className="text-danger">Error: {selectedCrypto.error}</p>
              <p>Please try again or contact support.</p>
              <button
                className="ppt_btn_primary"
                onClick={() => setCurrentScreen(3)}
              >
                Go Back
              </button>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-center mb-4">
                {selectedCrypto.qrCode && (
                  <img
                    src={selectedCrypto.qrCode}
                    alt="QR Code"
                    style={{ maxWidth: '200px', maxHeight: '200px' }}
                  />
                )}
              </div>
              <div className="text-center mb-4">
                <p>Send only {selectedCrypto.currency} to this deposit address.</p>
                <div className="ppt_input_style mb-3">
                  <input
                    type="text"
                    className="form-control"
                    value={selectedCrypto.address || ''}
                    readOnly
                  />
                </div>
                <button
                  className="ppt_btn_secondary"
                  onClick={() => {
                    navigator.clipboard.writeText(selectedCrypto.address || '');
                    alert('Address copied to clipboard!');
                  }}
                >
                  Copy Address
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default DepositModal;